PJQ.views.directcosts = PJQ.views.directcosts ? PJQ.views.directcosts : {};
PJQ.views.directcosts.DirectCostSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'direct-costs'),
        model: null,
        customFields: null
    },
    events: {

    },
    afterRender: function() {
        new PJQ.inputs.Selectpicker({
            el: this.$('.select-default-accounting-method'),
            isIntChoices: true,
            isMultiple: false,
            defaultValue: this.model.get('defaultAccountingMethod') != null ? this.model.get('defaultAccountingMethod') : PJQ.constants.budget.accountingMethod.UNIT_QUANTITY,
            onChange: _.bind(function (value) {
                this.model.set('defaultAccountingMethod', value);
                this.onChange();
            }, this)
        });
    },
    onChange: function (model) {
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(model ? model : this.model);
        }
    }
});
